/**
 * Server-side geo detection utilities
 * Uses Cloudflare's cf-ipcountry header for country detection during SSR
 */

import { createServerFn } from '@tanstack/react-start'
import { getRequest } from '@tanstack/react-start/server'
import { getCurrencyForCountry, type SupportedCurrency } from './currency-utils'

export type GeoData = {
  countryCode: string
  currency: SupportedCurrency
}

/**
 * Get user's geo data from Cloudflare headers
 * Uses cf-ipcountry header which is automatically set by Cloudflare
 * Falls back to US if header is not present (e.g., local development)
 */
export const getUserGeoData = createServerFn({ method: 'GET' })
  .handler(async (): Promise<GeoData> => {
    try {
      const request = getRequest()

      const countryCode = request.headers.get('cf-ipcountry')
        || request.headers.get('CF-IPCountry')
        || 'US'

      const currency = getCurrencyForCountry(countryCode)
      return {
        countryCode: countryCode.toUpperCase(),
        currency,
      }
    } catch (error) {
      // Fallback for local development or if request context is unavailable
      return {
        countryCode: 'US',
        currency: 'usd',
      }
    }
  })
